import React from 'react'

const CouponTagIcon = () => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.34021 1.51371C7.12146 1.2949 6.82477 1.17194 6.51537 1.17188H2.33171C2.02229 1.17188 1.72554 1.29479 1.50675 1.51358C1.28796 1.73238 1.16504 2.02912 1.16504 2.33854V6.52221C1.16511 6.8316 1.28806 7.1283 1.50687 7.34704L6.5842 12.4244C6.84934 12.6878 7.20793 12.8357 7.5817 12.8357C7.95548 12.8357 8.31407 12.6878 8.5792 12.4244L12.4175 8.58604C12.681 8.32091 12.8289 7.96231 12.8289 7.58854C12.8289 7.21477 12.681 6.85617 12.4175 6.59104L7.34021 1.51371Z" stroke="currentColor" strokeWidth="0.898123" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4.37565 4.66146C4.53673 4.66146 4.66732 4.53087 4.66732 4.36979C4.66732 4.20871 4.53673 4.07812 4.37565 4.07812C4.21457 4.07812 4.08398 4.20871 4.08398 4.36979C4.08398 4.53087 4.21457 4.66146 4.37565 4.66146Z" fill="currentColor" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default CouponTagIcon
